import React from 'react';
import cs from 'classnames';
import css from './index.css';
import {push as changeURL} from 'react-router-redux';
import {connect} from 'react-redux';
import mapDispatch from '~/misc/mapDispatch';
import * as urls from '~/routing/urls';
import {modalChange} from '~/modules/modal/actions';

const empty = (props) => {
  return (
    <div className={cs(css.addEmptyWrapper)}>
      <div className={cs(css.emptyWrapper)}>
        <img src="/assets/alert-empty-state.svg" alt=""/>
        <h4>You have not add any load alerts yet</h4>
        <p>Add load alerts to post your trucks on the Truckloads loadboard.</p>
        <button className={cs(css.alterButton)} onClick={props.goToAddAlert}>+  Add a load alert</button>
        <div className={cs(css.arrowWrapper)}>
          <img src="/assets/icon-arrow.svg" alt=""/>
          <div>Start here by adding a new load alert.</div>
        </div>
      </div>
    </div>
  )
}

export default connect(() => ({}), mapDispatch({
  goToAddAlert: (props) => {
    if(props.isPremium){
      return modalChange('pop', {
        source: 'alert',
        type: 'pop_upgrade_to_premium',
      });
    };
    return changeURL(`${urls.ALERT}/${urls.ALERTURL.AddAlert}`);
  },
}))(empty);



// WEBPACK FOOTER //
// ./src/components/Alert/AlertList/Empty/index.js